export default {
  SETOPTIONS(state, res) {
    Object.keys(res).forEach(item => (state[item] = res[item]))
  },
  setSearchData_M(state, res) {
    Object.keys(res).forEach(item => (state.searchData[item] = res[item]))
  },
  setCreateData_M(state, res) {
    Object.keys(res).forEach(item => (state.createData[item] = res[item]))
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Unit/mutations.js